import type { RoutePlanConfig } from 'hooks/usePlanSession/types';

export const TEST_ID = 'flightPlannerPanel';

export const SECTION_COVERAGE = 'coverage';

export const SECTION_ADVANCED = 'advanced';

export const SECTION_SPRAY = 'spray';

export const DEFAULT_SECTION_OPEN_STATE = {
    [SECTION_ADVANCED]: false,
    [SECTION_COVERAGE]: true,
    [SECTION_SPRAY]: false
};

export const DEBOUNCE_MS = 150;

export const DEBOUNCED_CONFIG_KEYS: readonly (keyof RoutePlanConfig)[] = [
    'altitudeAgl',
    'fieldMargin',
    'obstacleSafetyDistance',
    'pathAngleDegrees',
    'routeSpacing',
    'windFromDegrees'
] as const;

export const APPLICATION_TYPE_SPRAY_VALUE = 'SPRAY';

export const PRODUCT_CATEGORY_HERBICIDE = 'HERBICIDE';

export const DEFAULT_SPRAY_SETTINGS = {
    applicationType: APPLICATION_TYPE_SPRAY_VALUE,
    nozzleRatePercentage: 100,
    overlapMeters: 0,
    productCategory: PRODUCT_CATEGORY_HERBICIDE,
    rateKilogramsPerHectare: 0,
    rateLitersPerHectare: 100,
    speedMetersPerSecond: 6,
    turntablePercentage: 0
};
